import { useState } from 'react';

export default function usePdfViewer({ isMobile, isTablet, isDesktop }) {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  //states to manage PDF zoom level
  const [pdfZoom, setPdfZoom] = useState(isMobile ? 0.7 : isTablet ? 0.8 : 1.0);
  //Function to handle successful document load and set total pages
  const handleDocumentLoadSuccess = ({ numPages: total }) => {
    setNumPages(total);
  };
  //Page navigation handlers
  const handleBack = () => {
    setPageNumber((prev) => Math.max(prev - 1, 1));
  };
  const handleNext = () => {
    setPageNumber((prev) => Math.min(prev + 1, numPages));
  };
  //Function to handle zoom controls
  const handleZoomIn = () => {
    setPdfZoom((prev) => Math.min(prev + 0.2, 3.0));
  };

  const handleZoomOut = () => {
    setPdfZoom((prev) => Math.max(prev - 0.2, 0.3));
  };

  const handleResetZoom = () => {
    setPdfZoom(isMobile ? 0.7 : isTablet && !isDesktop ? 0.8 : 1.0);
  };

  return {
    numPages,
    pageNumber,
    pdfZoom,
    handleDocumentLoadSuccess,
    handleBack,
    handleNext,
    handleZoomIn,
    handleZoomOut,
    handleResetZoom,
  };
}
